import PropTypes from "prop-types";
import React, { useContext, ReactFragment } from "react";
import StaticContent from "../../context/ContentContext";
import { Link } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";



const NavMenu = ({ strings, menuWhiteClass, sidebarMenu }) => {
  const menuJson = useContext(StaticContent);

  const items = menuJson?.storeData?.data?.contentManagement?.data?.content?.items;
  const rawMenu = (items && items.length > 0) ? items[0].menu : [];

  // // Create a safe copy to avoid mutating context
  const menu = rawMenu ? [...rawMenu] : [];

  // USE STATIC DATA PROVIDED BY USER + NESTED TEST
  // const menu = [
  //   {
  //     "mainTitle": "home",
  //     "mainUrl": "/",
  //     "menuType": "link",
  //     "menus": [
  //       [
  //         {
  //           "type": "image",
  //           "url": "/assets/img/banner/banner-12.png",
  //           "shortCode": "home_group_one"
  //         }
  //       ]
  //     ]
  //   },
  //   {
  //     "mainTitle": "shop",
  //     "mainUrl": "/shop",
  //     "menuType": "submenu",
  //     "menus": [
  //       [
  //         {
  //           "__KEY__": "51e5c737-458e-4285-3549-3e415e141ea8",
  //           "shortCode": "sadsf",
  //           "url": "/shop"
  //         }
  //       ]
  //     ]
  //   },
  //   {
  //     "mainTitle": "pages",
  //     "mainUrl": "",
  //     "menuType": "submenu",
  //     "menus": [
  //       [
  //         {
  //           "type": "item",
  //           "url": "/pages/Test",
  //           "shortCode": "About"
  //         },
  //         {
  //           "type": "item",
  //           "url": "/pages/test2",
  //           "shortCode": "Contact"
  //         }
  //       ]
  //     ]
  //   },
  //   {
  //     "__KEY__": "3c6dbe3a-2a34-4695-1436-42b96fe82a1c",
  //     "mainTitle": "About",
  //     "menuType": "link",
  //     "mainUrl": "/pages/about",
  //     "menus": [
  //       [
  //         {
  //           "__KEY__": "46a5a7a9-c0ed-6360-5c51-d8ff7eb88c5c",
  //           "url": "/pages/about",
  //           "shortCode": "1"
  //         }
  //       ]
  //     ]
  //   },
  //   {
  //     "__KEY__": "58e709d2-8ef2-f54c-4884-ad8e722e97ed",
  //     "mainTitle": "contact",
  //     "menuType": "link",
  //     "mainUrl": "/pages/contact",
  //     "menus": [
  //       []
  //     ]
  //   },
  //   {
  //     "__KEY__": "c327e593-3e99-91b8-6a1b-1140f3a82ab6",
  //     "mainTitle": "Test",
  //     "menuType": "submenu",
  //     "mainUrl": "/home"
  //   },
  //   // NESTED TEST ITEM
  //   {
  //     mainTitle: "Nested Test",
  //     menuType: "submenu",
  //     mainUrl: "/",
  //     menus: [
  //       [
  //         {
  //           shortCode: "Level 1",
  //           url: "/",
  //           type: "title",
  //           children: [
  //             {
  //               shortCode: "Level 2 - A",
  //               url: "/",
  //               children: [
  //                 {
  //                   shortCode: "Level 3 - A",
  //                   url: "/"
  //                 },
  //                 {
  //                   shortCode: "Level 3 - B",
  //                   url: "/"
  //                 }
  //               ]
  //             },
  //             {
  //               shortCode: "Level 2 - B",
  //               url: "/"
  //             }
  //           ]
  //         }
  //       ]
  //     ]
  //   }
  // ];


  const checkType = (data) => {
    if (data === 'image') {
      return 'mega-menu-img'
    }
    if (data === 'title') {
      return 'mega-menu-title'
    }
    return ''
  }

  const checkMenuType = (data) => {
    if (data === 'megamenu') {
      return 'mega-menu'
    }
    if (data === 'submenu') {
      return 'submenu'
    }
    return ''
  }

  const RenderMenuItem = ({ item, checkType, strings }) => {
    const hasChildren = item.children && item.children.length > 0;
    return (
      <li className={checkType(item?.type)}>
        <Link to={process.env.PUBLIC_URL + item.url}>
          {item?.shortCode}
          {hasChildren && <i className="fa fa-angle-right" style={{ marginLeft: '5px' }}></i>}
        </Link>
        {hasChildren && (
          <ul className="submenu">
            {item.children.map((child, index) => (
              <RenderMenuItem
                key={index}
                item={child}
                checkType={checkType}
                strings={strings}
              />
            ))}
          </ul>
        )}
      </li>
    );
  };

  return (
    <div
      className={` ${sidebarMenu
        ? "sidebar-menu"
        : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
        } `}
    >
      {menuJson?.storeData?.data?.isActive && <nav>
        <ul>

          {menu?.map((data, key) => {
            return (
              <li key={key + 1} style={{ height: '77px' }}>
                {
                  checkMenuType(data.menuType) === 'submenu'
                    ? (
                      <button className='navButton'>
                        {data.mainTitle}
                        {data.menuType !== 'link' && (sidebarMenu ? (
                          <span>
                            <i className="fa fa-angle-right"></i>
                          </span>
                        ) : (
                          <i className="fa fa-angle-down" />
                        ))}
                      </button>
                    )
                    : (
                      <Link
                        style={{
                          textTransform: 'uppercase'
                        }}
                        to={process.env.PUBLIC_URL + data.mainUrl}>
                        {data.mainTitle}
                        {data.menuType !== 'link' && (sidebarMenu ? (
                          <span>
                            <i className="fa fa-angle-right"></i>
                          </span>
                        ) : (
                          <i className="fa fa-angle-down" />
                        ))}
                      </Link>
                    )
                }

                {data.menuType !== 'link' && (
                  <ul className={checkMenuType(data.menuType)}>
                    {data?.menus?.map((menu, index) => {
                      return (
                        <React.Fragment key={index + 500}>
                          {menu?.map((item, key) => {
                            return (
                              <RenderMenuItem
                                key={key + 55}
                                item={item}
                                checkType={checkType}
                                strings={strings}
                              />
                            )
                          })}
                        </React.Fragment>
                      )

                    })
                    }
                  </ul>)}
              </li>
            )
          })}


        </ul>
      </nav>}
    </div>
  );
};

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
  strings: PropTypes.object
};
export default multilanguage(NavMenu);
